var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;



//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/core-js/modules/_wks.js
// module id = ../../../../core-js/modules/_wks.js
// module chunks = 1